/* eslint-disable react-hooks/rules-of-hooks */
import { h, render } from 'preact';

import { parselyMyTeamStore } from '../../../global-store/subjects/parsely/my-team';
import { parselyMySportStore } from '../../../global-store/subjects/parsely/my-sport';
import { useSubscribe } from '../../hooks/use-subscribe';
import { preactWidget } from '../../utils';
import SlimBannerHP from '../../containers/slim-banner-HP/slim-banner-HP';

import widget from './widget-config';

const parselyStoreSubscriptions = {
  parselyMyTeam: () => useSubscribe(parselyMyTeamStore),
  parselyMySport: () => useSubscribe(parselyMySportStore),
};

export const hydrate = () => {
  const { $root, props } = preactWidget(widget);
  render(<SlimBannerHP {...props} parselyStoreSubscriptions={parselyStoreSubscriptions} />, $root);
};
